(function (aimi_calendar, $, app, undefined) {
  // Private object
  let __this = {};

  __this.calendars = {};

  aimi_calendar.list = {
    listRow: 'calender__list-row',
    init: function () {
      const $listContainer = $('[data-calendars]');

      __this.listMananger = new CalendarList(app, $listContainer, this.listRow, 'searchTable');

      __this.listMananger.renderList();

      $(document).off('click.aimi_calendar_list_delete').on('click.aimi_calendar_list_delete', 'tr:not(.pre-loader) .btn-delete', function (e) {
        let id = $(this).data('id');
        app.confirm("Delete Calendar?", "Are you sure you want to delete this Calendar?").then(function (response) {
          const $button = response.button;
          const confirm = response.confirm;
          const $modal = response.modal;

          // If the user confirms the deletion, proceed with the delete operation.
          if (confirm === true) {
            app.doButtonAction($button);
            app.apis['calendar'].delete(id).done(function (response) {
              if (response.success !== true) {
                const message = response.message;
                app.infoModal('Not Deleted', message);
              } else {
                // Render list if deleted
                __this.listMananger.renderList();
              }
              app.doButtonReset($button);
              app.hideModal($modal);
            }).fail(function (response) {
              app.doButtonReset($button, false);
              app.hideModal($modal);
            });
          }
        });
      });

      // Initializes scrollbar for the specified element
      new SimpleBar(document.getElementById('tab_block_1'), {autoHide: true});

    }

  }
}(window.aimi_calendar = window.aimi_calendar || {}, jQuery, PreBuilt));
